import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { AdminUser } from 'types/api/profile';

import { tokenStorage } from 'utils/storage';

type UserType = {
  user: AdminUser | null;
  isLoggedIn: boolean;
  isLoading: boolean;
};

const isLoggedIn = !!tokenStorage.get();

const initialState: UserType = {
  isLoggedIn,
  user: null,
  isLoading: true
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<AdminUser | null>) => {
      state.user = action.payload;
    },
    setIsLoggedIn: (state, action: PayloadAction<boolean>) => {
      state.isLoggedIn = action.payload;
    },
    setUserLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    }
  }
});

export const { setIsLoggedIn, setUserLoading, setUser } = userSlice.actions;
export default userSlice.reducer;
